import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import ButtonExportXml from './PropertiesPaneButtonExportXml.jsx'

import {
    PropertiesPaneButtonIntegrateMap as ButtonIntegrateMap,
    PropertiesPaneButtonClearMap as ButtonClearMap,
} from './PropertiesPaneButtonIntegrateMap.jsx'

const PropertiesPaneBatchVm = (props) => (
    <PropertiesPane
        buttons={
            <>
                <ButtonExportXml nodes={props.nodes} />
                <ButtonIntegrateMap />
                <ButtonClearMap />
            </>
        }

        {...props}
    />
)

export default PropertiesPaneBatchVm
